import apiClient from "./client";
import {
  startSession,
  getSession,
  autosave,
  submitSession,
  findInProgressSession,
} from "./sessions";
import type { Answer, ExamContent, Session } from "@/types";

/**
 * Listening API.
 * Content: GET /listening/tests/{test_id}
 * Sessions are handled by the shared /sessions endpoints with skill="listening".
 */

const SKILL = "listening" as const;

export async function getListeningExam(testId: number): Promise<ExamContent> {
  const { data } = await apiClient.get<ExamContent>(
    `/listening/tests/${testId}`
  );
  return data;
}

export const startListening = (testId: number): Promise<Session> =>
  startSession({ test_id: testId, skill: SKILL });

export const getListeningSession = (sessionId: number): Promise<Session> =>
  getSession(sessionId);

export const findListeningSession = (testId: number): Promise<Session | null> =>
  findInProgressSession(testId, SKILL);

export const saveListeningAnswers = (
  sessionId: number,
  answers: Answer[]
): Promise<Session> => autosave(sessionId, answers);

export const submitListening = (
  sessionId: number,
  answers: Answer[]
): Promise<Session> => submitSession(sessionId, { answers });
